import React from 'react';

import { useMutation } from 'react-query';
import { useRouter } from 'next/router';
import UseToast from 'hooks/use-toast';
import UseModal from 'hooks/use-modal';
import useAction from 'hooks/use-action';

import { LectureAddToCart } from 'services/payments';
import { LectureModule, LectureRelaunchModule, CourseWaitingList, LectureRetake } from 'services/core';
import { MOBILE_FULLSCREEN, CONFIRMATION } from '@core/constants/ModalTypes';
import { getErrorText } from 'utils/geterrortext';

import ContentCertificate from 'components/common/contentcertificate/ContentCertificate';
import LoginPrompt from 'components/common/loginprompt/LoginPrompt';
import Modal from '@core/components/Modal/Modal';
import ActionButton from '@core/components/actionbutton/ActionButton';
import SurveyCertificateWrapper from 'components/pages/lecture/lecturemainbutton/surveycertificatewrapper/SurveyCertificateWrapper';
import LinkButton from '@core/components/linkbutton/LinkButton';
import TimeCounter from '@core/components/timecounter/TimeCounter';

import ShopIcon from '@core/assets/icons/shop-icon.svg';
import LimitLectureIcon from 'assets/icons/course-open.svg';
import { Lock1 } from 'iconsax-react';
// import CloseSquare from '@core/assets/icons/close-square.svg';

import {
	ReadyForFree,
	// Lacking,
	// Purchasing,
	Ready,
	Completed,
	Progressing,
	Quiz,
	Unsuccessful,
	// Passed,
	ComingSoon
} from 'constants/content-status';
import { CART_REFETCH_ACTION } from 'constants/Actions';

import classes from './LectureMainButton.module.scss';





const LectureMainButton = ({ lecture_id, status, refetchOverview, kind, unlock_in }) => {
	const router = useRouter();
	const { toast, ToastContainer } = UseToast();
	const [actionHandler] = useAction();
	const {
		show: loginNoticeVisible,
		showModal: loginNoticeShowModal,
		destroyModal: loginNoticeDestroyModal
	} = UseModal();
	const {
		show: certificateModalVisible,
		showModal: certificateShowModal,
		destroyModal: certificateDestroyModal
	} = UseModal();
	const {
		show: retakeModalVisible,
		showModal: retakeShowModal,
		destroyModal: retakeDestroyModal
	} = UseModal();
	const {
		show: lectureLimitationVisible,
		showModal: lectureLimitationModal,
		destroyModal: lectureLimitationDestroyModal
	} = UseModal();

	const { mutate: callAddToCart, isLoading: addToCardLoading } = useMutation(LectureAddToCart, {
		onSuccess: (data) => {
			refetchOverview();
			toast(
				<>
					<ShopIcon /> {data.data?.message}
				</>
			);
			actionHandler({ type: CART_REFETCH_ACTION });
		},
		onError: (error) => {
			if (error.response.status === 401) {
				loginNoticeShowModal();
			} else {
				toast(error.response.data.data, 'Alert');
			}
		}
	});
	const { mutate: callLectureModule, isLoading: lectureModuleLoading } = useMutation(
		LectureModule,
		{
			onSuccess: (data) => {
				setTimeout(() => window?.open(data.data.launch_link), 0);
			},
			onError: (error) => {
				if (error.response.status === 401) {
					loginNoticeShowModal();
				} else if (error.response.status === 428) {
					toast(error.response.data.data, 'Alert');
				}
				else if (error.response.status === 400) {	
					toast(getErrorText(error), 'Alert');
				}
			}
		}
	);
	const { mutate: callLectureRelaunchModule, isLoading: lectureRelauncModuleLoading } = useMutation(
		LectureRelaunchModule,
		{
			onSuccess: (data) => {
				setTimeout(() => window?.open(data.data.launch_link), 0);
			},
			onError: (error) => {
				if (error.response.status === 400)
					toast(error.response.data.data, 'Alert');
			}
		}
	);
	const { mutate: callLectureRetake, isLoading: lectureRtakeLoading } = useMutation(
		LectureRetake,
		{
			onSuccess: (data) => {
				toast(data.data?.message, 'info');
				retakeDestroyModal();
				setTimeout(() => window?.location.reload(), 2000);
			},
			onError: (error) => {
				retakeDestroyModal();
				if (error.response.status === 400)
					toast(error.response.data.data, 'Alert');
			}
		}
	);
	const { mutate: callAddToWaitingList, isLoading: addToWaitingListLoading } = useMutation(
		CourseWaitingList.POST,
		{
			onSuccess: (data) => {
				toast(
					<div className="d-flex gap-3">
						<ShopIcon /> {data.data?.message}
					</div>
				);
			},
			onError: (error) => {
				if (error.response.status === 401) {
					loginNoticeShowModal();
				} else {
					toast(error.response.data.data, 'Alert');
				}
			}
		}
	);

	const buttonTypeHandler = () => {
		switch (status) {
			case ReadyForFree:
				return (
					<>
						{unlock_in ? (
							<>
								<div className={classes['limit-lecture']}>
									<ActionButton
										disabled={lectureModuleLoading}
										loading={lectureModuleLoading}
										onClick={() => lectureLimitationModal()}
										className={`${classes['content-button']} `}
									>
										<Lock1 size="16" color="#FFF" className='me-2' />
										Start learning for free
									</ActionButton>
									<LinkButton kind='simple' to={'/plans'}>Unlock all courses</LinkButton>
								</div>
								<div className={classes['counter-wrapper']} >
									<span>
										Available in:
									</span>
									<TimeCounter time={unlock_in} />
								</div>
							</>
						) : (
							<ActionButton
								disabled={lectureModuleLoading}
								loading={lectureModuleLoading}
								onClick={() => callLectureModule(lecture_id)}
								className={`${classes['content-button']}`}
							>
								Start learning for free
							</ActionButton>
						)}

					</>

				);
			// case Lacking:
			// 	return (
			// 		<ActionButton
			// 			disabled={addToCardLoading}
			// 			loading={addToCardLoading}
			// 			onClick={() => callAddToCart({ id: lecture_id })}
			// 			className={`${classes['content-button']}`}>
			// 			Add to cart
			// 		</ActionButton>
			// 	);
			// case Purchasing:
			// 	return (
			// 		<ActionButton
			// 			onClick={() => router.push('/cart')}
			// 			className={`${classes['content-button']}`}>
			// 			Finalize purchase...
			// 		</ActionButton>
			// 	);
			case Ready:
				return (
					<ActionButton
						disabled={lectureModuleLoading}
						loading={lectureModuleLoading}
						onClick={() => callLectureModule(lecture_id)}
						className={`${classes['content-button']}`}>
						Start learning now!
					</ActionButton>
				);
			case Progressing:
				return (
					<>
						<ActionButton
							kind={kind ? kind : "primary"}
							disabled={lectureModuleLoading}
							loading={lectureModuleLoading}
							onClick={() => callLectureModule(lecture_id)}
							className={`${classes['content-button-half']}`}>
							Continue learning
						</ActionButton>
					</>
				);
			case Completed:
				return (
					<>
						<ActionButton
							disabled={lectureModuleLoading}
							loading={lectureModuleLoading}
							onClick={() => certificateShowModal()}
							className={`${classes['content-button-half']}`}>
							Receive certificate!
						</ActionButton>
						<div className='d-flex flex-column align-items-start w-100'>
							<ActionButton
								kind='blank'
								disabled={lectureRelauncModuleLoading}
								loading={lectureRelauncModuleLoading}
								onClick={() => callLectureRelaunchModule(lecture_id)}
								className={` mt-3 ${classes['content-button-half']}`}>
								Rewatch the course
							</ActionButton>
							<ActionButton
								kind='blank'
								disabled={lectureModuleLoading}
								loading={lectureModuleLoading}
								onClick={() => retakeShowModal()}
								className={`${classes['content-button-half']}`}>
								Retake the course
							</ActionButton >
						</div>
					</>
				);
			case Quiz:
				return (
					<>
						<ActionButton
							kind={kind ? kind : "primary"}
							disabled={lectureModuleLoading}
							loading={lectureModuleLoading}
							onClick={() => callLectureModule(lecture_id)}
							className={`${classes['content-button-half']}`}>
							Take quiz...
						</ActionButton>
						<div className='w-100'>
							<ActionButton
								kind="blank"
								disabled={lectureRelauncModuleLoading}
								loading={lectureRelauncModuleLoading}
								onClick={() => callLectureRelaunchModule(lecture_id)}
								className={`${classes['content-button-half']} py-3`}>
								Rewatch the course
							</ActionButton>
						</div>
					</>
				);
			case Unsuccessful:
				return (
					<>
						<ActionButton
							kind={kind ? kind : "primary"}
							disabled={lectureModuleLoading}
							loading={lectureModuleLoading}
							onClick={() => callLectureModule(lecture_id)}
							className={`${classes['content-button-half']}`}>
							Retake quiz...
						</ActionButton>
						<div className='w-100'>
							<ActionButton
								kind="blank"
								disabled={lectureRelauncModuleLoading}
								loading={lectureRelauncModuleLoading}
								onClick={() => callLectureRelaunchModule(lecture_id)}
								className={`${classes['content-button-half']} py-3`}>
								Rewatch the course
							</ActionButton>
						</div>
					</>
				);
			// case Passed:
			// 	return (
			// 		<>
			// 			<ActionButton
			// 				kind={kind ? kind : "primary"}
			// 				disabled={lectureRelauncModuleLoading}
			// 				loading={lectureRelauncModuleLoading}
			// 				onClick={() => callLectureRelaunchModule(lecture_id)}
			// 				className={`${classes['content-button-half']} py-3`}>
			// 				Rewatch the course
			// 			</ActionButton>
			// 		</>
			// 	);
			case ComingSoon:
				return (
					<ActionButton
						disabled={addToWaitingListLoading}
						loading={addToWaitingListLoading}
						onClick={() => callAddToWaitingList(lecture_id)}
						className={`${classes['content-button']}`}>
						Join waiting list
					</ActionButton>
				);
		}
	};

	return (
		<>
			<ToastContainer />
			<Modal
				type={MOBILE_FULLSCREEN}
				closeHandler={certificateDestroyModal}
				show={certificateModalVisible}
				backgroundColor='#FFF5E5'
			>
				{/* <div
					className={`${classes['certificate-modal']} d-flex flex-column justify-content-center`}>
					<ContentCertificate content_type="lecture" />
				</div> */}
				<SurveyCertificateWrapper />
			</Modal>
			<Modal
				type={MOBILE_FULLSCREEN}
				closeHandler={loginNoticeDestroyModal}
				show={loginNoticeVisible}>
				<div
					className={`${classes['login-notice-modal']} d-flex flex-column justify-content-center container`}>
					<div className={`d-flex flex-column align-items-center justify-content-center`}>
						<LoginPrompt />
					</div>
				</div>
			</Modal>
			<Modal
				type={CONFIRMATION}
				closeHandler={retakeDestroyModal}
				header={false}
				show={retakeModalVisible}>
				<div
					className={`${classes['certificate-modal']} d-flex flex-column justify-content-center`}>
					<p>Do you want to retake the course and get a new certificate?</p>
					<div className='d-flex justify-content-end w-100 mt-4'>
						<ActionButton kind='simple' onClick={() => retakeDestroyModal()}>No</ActionButton>
						<ActionButton kind='simple-alert' onClick={() => callLectureRetake(lecture_id)} >Yes</ActionButton>
					</div>
				</div>
			</Modal>
			<Modal
				type={MOBILE_FULLSCREEN}
				closeHandler={lectureLimitationDestroyModal}
				header={false}
				show={lectureLimitationVisible}
				isGoPermium={true}
			>
				<div className={classes['lecture-limited-modal']}>
					<LimitLectureIcon />
					<h5 >You are using the Free Plan, your next free course unlocks in:</h5>
					<TimeCounter time={unlock_in} />
					<span>or</span>
					<h4>Unlock all courses with Premium Plan</h4>
					<LinkButton kind='primary-color' to='/plans'>Unlock All Courses</LinkButton>
				</div>
			</Modal>
			{buttonTypeHandler()}
		</>
	);
};

export default React.memo(LectureMainButton);
